const disputeClaimsES = {
    "view": {
        "table": {
            "title": "Tus Infracciones de Derechos de Autor",
            "columns": {
                "release": "Lanzamiento",
                "user": "Usuario",
                "store": "Tienda",
                "claimantName": "Nombre del Reclamante",
                "claimantEmail": "Correo del Reclamante",
                "resolutionTime": "Tiempo de Resolución",
                "remainingTime": "Tiempo Restante",
                "status": "Estado"
            },
            "label": {
                "status_created": "Creado",
                "status_pending": "Pendiente",
                "status_in_progress": "En Progreso",
                "status_resolved": "Resuelto",
                "status_copyright_violation": "Violación de Derechos de Autor"
            },
            "button": {
                "exportCSV": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            }
        }
    }
};

export default disputeClaimsES;